
var api_base = "/api/v1/";


$(document).ready(function () {

    $(".formwidget").each(function () {

        //var id = $(this).attr('id');
        //$('#' + id).prependTo('#bizform-form-section');     

        $("#bizform-form-section div").removeClass("offset-lg-2");
        $("#bizform-form-section .col-lg-4").addClass("col-lg-6");
        $("#bizform-form-section div").removeClass("col-lg-4");

        $("#bizform-form-section .col-lg-8").addClass("col-lg-12");
        $("#bizform-form-section div").removeClass("col-lg-8");

        $(".inforline-form div").removeClass("offset-lg-2");
        $(".inforline-form .col-lg-4").addClass("col-lg-6");
        $(".inforline-form div").removeClass("col-lg-4");

        $(".inforline-form .col-lg-8").addClass("col-lg-12");
        $(".inforline-form div").removeClass("col-lg-8");

    });

    $(".main-nav.main-nav-mater li a").each(function () {

        if (window.location.href.indexOf($(this).prop("href")) > -1) {
            $(this).find("span").addClass("menu-overlay-d");
        }
        else {
            $(this).find("span").removeClass("menu-overlay-d");
        }

    });

    $('#icon-mail').on('click', function () {
        $('.inforline-form').stop(true, true).slideDown();
        $(this).hide();
        $('#icon-form-close').show();
    });

    $('#icon-form-close').on('click', function () {
        $('.inforline-form').stop(true, true).slideUp();
        $(this).hide();
        $('#icon-mail').show();
    });

    //$('.orthopaedics-nav').find('#primary-nav').clone(true, true).insertAfter(".nav-wrapper #primary-nav");

    const toggleBtn = document.querySelector(".ortho-nav-toggle");
    const menu = document.getElementById("header-mobile-menu");
    const icon = document.getElementById("menu-icon");

    if (toggleBtn && menu && icon) {
        toggleBtn.addEventListener("click", function () {
            const isExpanded = !menu.classList.contains("d-none");
            menu.classList.toggle("d-none");

            //Change the icon
            icon.textContent = isExpanded ? "☰" : "✕";
        });

        const navLinks = document.querySelectorAll(".header-nav-item");
        navLinks.forEach(function (link) {
            link.addEventListener("click", function () {
                if (window.innerWidth < 992) {
                    menu.classList.toggle("d-none");
                    icon.textContent = "☰";
                }
            });
        });
    }

});
if (document.getElementsByClassName("current")[0] != undefined) {
    if (document.getElementsByClassName('current')[0].innerHTML.includes(', VIC') || document.getElementsByClassName('current')[0].innerHTML.includes(', NSW') || document.getElementsByClassName('current')[0].innerHTML.includes(', QLD')) {
        window.onload = localStorage.setItem("Hospital", document.getElementsByClassName('current')[0].innerText);
    }
	if ($("a[href^='/services?']")[0] !== undefined) {
            window.onload = localStorage.setItem("SeviceURl", $("a[href^='/services?']")[0].href);
    }
    if ($("a[href^='/services?']")[0] !== undefined) {
            window.onload = localStorage.setItem("SpecialistURl", $("a[href^='/specialists?']")[0].href);
    }
}
window.onload = setHospitalValue();

function OrthoContact(form) {

    if (form === 'ortho-form') {

        $('.inforline-form').stop(true, true).slideDown();
        $('#icon-mail').hide();
        $('#icon-form-close').show();
    }
}

function onTreatmentChange(id) {

    $.ajax({
        type: "GET",
        url: api_base + "Service/GetProcedureFilterData",
        data: {
            treatmentId: id
        },
        contentType: "application/json",
        success: function (data) {

            $("#drProcedure").empty();

            for (var i = 0; i < data.length; i++) {

                var o = new Option(data[i].name, data[i].value);
                $("#drProcedure").append(o);

            }

            if (data.length > 0) {

                $("#p-title").html(data[0].title);
                $("#p-body").html(data[0].body);
            }

        }
    });

}


function onProcedureChange(id) {

    $.ajax({
        type: "GET",
        url: api_base + "Service/GetProcedureData",
        data: {
            procedureId: id
        },
        contentType: "application/json",
        success: function (data) {

            $("#p-title").html(data.title);
            $("#p-body").html(data.body);


        }
    });

}


function filterSelection(c) {

    var x, i;
    x = document.getElementsByClassName("filter-div");

    if (c == "All") {

        $(".link-filter").each(function () {
            $(this).removeClass("link-filter-selected");
        });

        $(".link-filter." + c).addClass("link-filter-selected");

        c = "";

        for (i = 0; i < x.length; i++) {
            svRemoveClass(x[i], "show");
            if (x[i].className.indexOf(c) > -1) svAddClass(x[i], "show");
        }
    }
    else {

        for (i = 0; i < x.length; i++) {
            svRemoveClass(x[i], "show");
            if (x[i].className.indexOf(c) > -1) svAddClass(x[i], "show");
        }

        $(".link-filter").each(function () {
            $(this).removeClass("link-filter-selected");
        });

        $(".link-filter." + c).addClass("link-filter-selected");
    }
}

function svAddClass(element, name) {

    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");

    for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) { element.className += " " + arr2[i]; }
    }

}

function svRemoveClass(element, name) {

    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
            arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
    }
    element.className = arr1.join(" ");
}

/* popup start */

window.onload = function () {
    if (document.getElementById('customModal') && checkCorporatePopupCookie()) {

        document.getElementById('customModal').style.display = 'block';

        document.getElementById('modalCloseBtn').onclick = function () {
            document.getElementById('customModal').style.display = 'none';
            setCorporatePopupCookie("corporatepopupcookie", "corp", 10000);
        };

        document.getElementById('closeFooterBtn').onclick = function () {
            document.getElementById('customModal').style.display = 'none';
            setCorporatePopupCookie("corporatepopupcookie", "corp", 10000);
        };
    }
};


function OnFindOutMoreClick() {

    setCorporatePopupCookie("corporatepopupcookie", "corp", 10000);

    let a = document.createElement('a');
    a.target = '_blank';
    a.href = 'https://www.svha.org.au/about/our-strategy';
    a.click();
}

function setCorporatePopupCookie(cname, cvalue, exdays) {

    let cookie = getCorporatePopupCookie("corporatepopupcookie");

    if (cookie == "") {

        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

    }

}

function getCorporatePopupCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCorporatePopupCookie() {
    let cookie = getCorporatePopupCookie("corporatepopupcookie");
    if (cookie != "") {
        return false;
    } else {
        return true;
    }
}

/* popup end */